import { sortArrayOfObjectsByProperty } from './sortArrayOfObjectsByProperty.js';

const array = {
    sortArrayOfObjectsByProperty
};

export { array };
